export const attitudeStyles = {
  PIC: { backgroundColor: '#dff4d8', borderColor: '#9ecf93' },
  PIN: { backgroundColor: '#f0f0f0', borderColor: '#c9c9c9' },
  MOTS: { backgroundColor: '#f7d7da', borderColor: '#e0a6ae' },
}

export const dayLabels = ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su']
export const calendarAnchorPosition = { nationalSeason: 41, part: 1, week: 3, day: 7 }
export const calendarAnchorDate = new Date('2026-04-19T12:00:00')
export const u21CalendarAnchorPosition = {
  nationalSeason: 41,
  part: 1,
  week: 3,
  day: 1,
}
export const u21CalendarAnchorDate = new Date('2026-08-03T12:00:00')
export const daysPerWeek = 7
export const weeksPerPart = 16
export const daysPerPart = weeksPerPart * daysPerWeek
export const daysPerSeason = daysPerPart * 2
export const HOME_ADVANTAGE_FACTOR = 1.096608

export const defaultOpponentCountries = [
  'Latvia',
  'Itävalta',
  'Malta',
  'Kypros',
  'Albania',
]

export const defaultCountryValues = {
  attitude: 'PIC',
  midfieldInput: '',
  formation: '',
  tactic: '',
  manualSpiritBeforeInput: '',
  midfieldAnchor: false,
}
